export default function Style(){
  return (
    <style>
      {`
       @media (max-width: 768px) {
   .res-fs-size {
     font-size: 32px !important;
     line-height: 40px !important;
   }
 }

 @media (max-width: 992px) {
   .res-fs-size {
     font-size: 38px !important;
     line-height: 48px !important;
   }
 }

 @media (max-width: 1534px) {
  .fs-14-16 {
    font-size: 14px !important;
    line-height: 21px !important;
  }

  .res-fs-size {
    font-size: 44px !important;
    line-height: 55px !important;
  }

  .responsiveText {
    font-size: 22px !important;
    line-height: 33px !important;
  }
}

 @media (min-width: 1543px) {

   .fs-14-16 {
     font-size: 16px !important;
     line-height: 24px !important;
   }

   .responsiveText {
     font-size: 24px !important;
     line-height: 36px !important;
   }

   .res-fs-size {
     font-size: 48px !important;
     line-height: 60px !important;
   }
 }

        `}
    </style>
  );
}

